'use client';

import { Button, Input } from '@holistic/components';
import { LogIn, User, UserPlus } from '@holistic/components/icons';

import IdentityNumberField from '../identity-number-field';

export type GuestCheckoutErrors = {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
};

type GuestCheckoutProps = {
  isGuestMode: boolean;
  onChooseGuest: () => void;
  onChooseLogin: () => void;
  onChooseRegister: () => void;
  firstName: string;
  onFirstNameChange: (v: string) => void;
  lastName: string;
  onLastNameChange: (v: string) => void;
  phoneNumber: string;
  onPhoneNumberChange: (v: string) => void;
  email: string;
  onEmailChange: (v: string) => void;
  /**
   * TCKN üyelikte cihaz kartında sorulur; misafirde ise diğer kimlik
   * bilgileriyle aynı kartta durması daha anlaşılır oluyor.
   */
  identityNumber: string;
  onIdentityNumberChange: (v: string) => void;
  identityNumberError: string | null;
  errors: GuestCheckoutErrors;
};

const GuestCheckout = ({
  isGuestMode,
  onChooseGuest,
  onChooseLogin,
  onChooseRegister,
  firstName,
  onFirstNameChange,
  lastName,
  onLastNameChange,
  phoneNumber,
  onPhoneNumberChange,
  email,
  onEmailChange,
  identityNumber,
  onIdentityNumberChange,
  identityNumberError,
  errors,
}: GuestCheckoutProps) => {
  if (!isGuestMode) {
    return (
      <div className="flex flex-col gap-3">
        <p className="text-sm text-gray-500">
          Devam etmek için giriş yapın, üye olun ya da üye olmadan devam edin.
        </p>
        <div className="flex flex-col gap-2 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            onClick={onChooseLogin}
          >
            <LogIn className="mr-1.5 size-4" />
            Giriş Yap
          </Button>
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            onClick={onChooseRegister}
          >
            <UserPlus className="mr-1.5 size-4" />
            Üye Ol
          </Button>
          <Button
            type="button"
            variant="outline"
            className="flex-1"
            onClick={onChooseGuest}
          >
            <User className="mr-1.5 size-4" />
            Üye Olmadan Devam Et
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-baseline justify-between gap-4">
        <p className="text-sm text-gray-500">Üye olmadan devam ediyorsunuz.</p>
        <button
          type="button"
          onClick={onChooseGuest}
          className="text-primary text-xs font-medium hover:underline"
        >
          Değiştir
        </button>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">
            Ad <span className="text-red-500">*</span>
          </label>
          <Input
            value={firstName}
            onChange={(e) => onFirstNameChange(e.target.value)}
            placeholder="Adınız"
            error={errors.firstName}
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">
            Soyad <span className="text-red-500">*</span>
          </label>
          <Input
            value={lastName}
            onChange={(e) => onLastNameChange(e.target.value)}
            placeholder="Soyadınız"
            error={errors.lastName}
          />
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">
            Telefon Numarası <span className="text-red-500">*</span>
          </label>
          <Input
            value={phoneNumber}
            onChange={(e) => onPhoneNumberChange(e.target.value)}
            placeholder="05XX XXX XX XX"
            inputMode="tel"
            error={errors.phoneNumber}
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">
            E-posta <span className="text-red-500">*</span>
          </label>
          <Input
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder="ornek@eposta.com"
            inputMode="email"
            error={errors.email}
          />
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <IdentityNumberField
          value={identityNumber}
          onChange={onIdentityNumberChange}
          error={identityNumberError}
        />
      </div>

      {!errors.phoneNumber && (
        <p className="text-xs leading-relaxed text-gray-400">
          Telefon numaranızı eklerseniz, talebinizin durumunu bu numara ve talep
          numaranızla sorgulayabilirsiniz.
        </p>
      )}
    </div>
  );
};

export default GuestCheckout;
